// NGXS
import {
  AddNursingStations,
  DeletePickUpTray,
  AddNSSettings,
  SaveIntakeReasons,
} from '../actions/pickup.action';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { INursingStationPickup } from '../../models/pickup/pickup-utilities.model';
import {
  IIntakeReason,
  IPickupSetting,
} from '../../models/service/pickup-settings.model';
import { Injectable } from '@angular/core';

export interface NursingStationStateI {
  nursingStations: INursingStationPickup[];
  pickupSettings: IPickupSetting;
  intakeReasons: IIntakeReason[];
}

@State<NursingStationStateI>({
  name: 'NursingStationState',
  defaults: {
    nursingStations: [],
    pickupSettings: null,
    intakeReasons: null,
  },
})
@Injectable({
  providedIn: 'root',
})
export class PickupState {
  // Units
  @Selector()
  static getNursingStations(state: NursingStationStateI): NursingStationStateI {
    return state;
  }

  //Reasons
  @Selector()
  static getIntakeReasons(state: NursingStationStateI): IIntakeReason[] {
    return state.intakeReasons;
  }

  @Action(AddNursingStations)
  addNursingStations(
    { patchState }: StateContext<NursingStationStateI>,
    { payload }: AddNursingStations,
  ): void {
    patchState({
      nursingStations: [...payload],
    });
  }

  @Action(DeletePickUpTray)
  deleteNursingStationsTray(
    { patchState, getState }: StateContext<NursingStationStateI>,
    { payload }: DeletePickUpTray,
  ): void {
    const nursingStations = [...getState().nursingStations];
    const nursingStationIndex = nursingStations.findIndex(nursingStationEl => {
      return nursingStationEl.Oid === payload.nursingStationId;
    });
    nursingStations[nursingStationIndex] = {
      ...nursingStations[nursingStationIndex],
      trays: nursingStations[nursingStationIndex].trays.filter(
        trayEl => trayEl.trayOid !== payload.trayId,
      ),
    };
    patchState({ nursingStations });
  }

  @Action(AddNSSettings)
  addNSSettings(
    { patchState }: StateContext<NursingStationStateI>,
    { payload }: AddNSSettings,
  ): void {
    patchState({
      pickupSettings: payload,
    });
  }

  @Action(SaveIntakeReasons)
  saveIntakeReasons(
    { patchState }: StateContext<NursingStationStateI>,
    { payload }: SaveIntakeReasons,
  ): void {
    patchState({
      intakeReasons: payload.intakeReasons,
    });
  }
}
